<template>
  <div>

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />


    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >

      <div class="px-5 lg:px-10 pt-8 pb-4">

          <div class="pb-6"> 
            <button @click="this.update = false" v-if="this.update == true" class="bg-blues text-white px-4 py-1 rounded-xl mt-4">Back</button>
          </div>

          <div class="flex items-center justify-between flex-wrap lg:flex-nowrap">
            <div>
              <h1 class="text-lg font-semibold ">CO PO PSO MAPPING</h1>
            </div>
          </div>

          <!-- {{ sendJSON }} -->
          <div class="flex items-center justify-end gap-6"> 
            <button @click="iscoPopup = true" v-if="pso.length < 6" class="bg-blues text-white px-4 py-1 rounded-xl mt-4">Create Post CO</button>
          
            <button @click="this.update = true" v-if="this.update == false" class="bg-blues text-white px-4 py-1 rounded-xl mt-4">Update</button>
            <button @click="sendDataUpdate" v-if="this.update == true" class="bg-blues text-white px-4 py-1 rounded-xl mt-4">Submit</button>
          </div>  

           <table class="mt-6 w-full" v-if="this.update == false"> 
              <thead> 
                
                <tr> 
                  <th>CO / PO</th>
                  <th v-for="i in 12" :key="i">PO {{ i }}</th>
                  <th v-for="i in 3" :key="i">PSO {{ i }}</th>
                </tr>
              </thead>
              <tbody> 
                <tr v-for="i in pso.length" :key="i">
                  <td>{{ pso[i-1].co }}</td>
                  <td v-for="i in pso[i-1].po_mappings" :key="i">{{ i.mark }}</td>
                  <td v-for="i in pso[i-1].pso_mappings" :key="i"> {{ i.mark }}</td>
                </tr>
              </tbody>
            </table> 

            

            <table class="mt-6 w-full" v-if="this.update"> 
              <thead> 
                
                <tr> 
                  <th>CO / PO</th>
                  <th v-for="i in 12" :key="i">PO {{ i }}</th>
                  <th v-for="i in 3" :key="i">PSO {{ i }}</th>
                </tr>
              </thead>
              <tbody> 
                <tr v-for="i in pso.length" :key="i">
                  <td>{{ pso[i-1].co }}</td>
                  <td v-for="i in pso[i-1].po_mappings" :key="i"><input type="number" class="w-10" min="1" max="3" v-model="i.mark" @blur="validateMark(i)"></td>
                  <td v-for="i in pso[i-1].pso_mappings" :key="i"><input type="number" class="w-10" min="1" max="3" v-model="i.mark" @blur="validateMark(i)"></td>
                </tr>
              </tbody>
            </table>

            <p class="px-1 py-3 text-sm mt-4">High-3, Medium-2, Low-1</p>

            <!-- <table class="mt-10 w-full"> 
              <thead> 
                
                <tr> 
                  <th>CO / PO</th>
                  <th v-for="i in 12" :key="i">PO {{ i }}</th>
                  <th v-for="i in 3" :key="i">PSO {{ i }}</th>
                </tr>
              </thead>
              <tbody> 
                

                <tr v-for="i in co_count" :key="i">
                  <td>CO {{ i }}</td>
                  <td v-for="j in 12" :key="j"><input type="number" v-model.number="inputs['co'+i]['po'+j]" class="w-10" min="1" max="3"></td>
                  <td v-for="k in 3" :key="k"> <input type="number" v-model.number="inputs['co'+i]['pso' + k]" class="w-10" min="1" max="3"></td>
                </tr>
              </tbody>
            </table> -->
          
      </div>

      </div>
    </div>


    <div
            v-if="this.iscoPopup"
            class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
          >
            <div
              class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
            >
              <div class="flex items-center justify-between">
                <h3 class="text-xl font-bold text-textblues">Add CO</h3>
                <img
                  src="@/assets/newd/close.png"
                  class="cursor-pointer"
                  alt=""
                  @click="this.iscoPopup = false"
                />
              </div>

              <div
                class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
              >
                <div class="w-full">
                  <form
                    ref="addComappingRef"
                    @submit.prevent="postCO"
                    class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                  >
                    <!-- <div
                      class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                    >
                      <div class="w-full flex flex-col gap-2">
                        <label for="title" class="text-left">Title</label>
                        <input
                          id="title"
                          type="text"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div>
                    </div> --> 

                    <!-- {{ pso.length + 1 }} -->

                    <div class="flex flex-col w-full gap-2">
                      <label for="description" class="text-left"
                        >Description</label
                      >
                      <textarea
                        id="description"
                        rows="3"
                        cols="10"
                        class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      />
                    </div>
            
                    <div class="flex justify-end pb-4 mt-3">
                      <button
                        type="submit"
                        class="text-black border border-black rounded-lg text-sm px-10 py-2"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue"; 

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
  },
  data() {

    const inputs = {};
    for (let i = 1; i <= 10; i++) {
      inputs['co'+i] = {};
      for (let j = 1; j <= 12; j++) {
        inputs['co'+i]['po'+j] = null;
      }
      for (let k = 1; k <= 3; k++) {
        inputs['co'+i]['pso'+k] = null;
      }
    }

    return {
      co_count: 10,
      pso: [],
      sendJSON: [],
      update: false,
      messages: {
        text: "",
        type: "null",
      },
      isInvalid: false,
      iscoPopup: false,
      // inputs: "",
      inputs
    };
  },

  created() {
      this.getPSO();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    
  },

  methods: {

    validateMark(item) {
      if (item.mark < 1) {
        item.mark = 1;
        alert("1 to 3 only allowed.");
      } 
      if(item.mark > 3){
        item.mark = 3;
        alert("1 to 3 only allowed.");
      }
    },

    sendDataUpdate(){
      this.sendJSON = [];

      this.pso.forEach((item) => {
        item.po_mappings.forEach((po) => {
          this.sendJSON.push({ po_id: po.po_id, mark: po.mark });
        });
        item.pso_mappings.forEach((pso) => {
          this.sendJSON.push({ pso_id: pso.pso_id, mark: pso.mark });
        });
      });

      console.log(this.sendJSON);

      axios.patch(`${process.env.VUE_APP_API}/po/pso/update/?Key=${this.userInfo.token_key}`, this.sendJSON)
        .then((response)=>{
          this.messages = {
              text: response.data.message,
              type: "success",
            };
            
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.getPSO();
              this.update = false;
            }, 1500);
        })
    },

    async postCO(){
      await axios
        .post(
          `${process.env.VUE_APP_API}/courseoutcome/create/?Key=${this.userInfo.token_key}`,
          {
              "title": `CO ${this.pso.length + 1}`,
              "description": document.getElementById("description").value,
              "course": this.course_id,
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.$refs.addComappingRef.reset();
            this.iscoPopup = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.getPSO();
            }, 1500);
          }
        })
        .catch((err)=>{
          if(err.status == 400){
            this.messages = {
              text: "CO 6 Times can only create.",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.getPSO();
            }, 1500);
          }
        })
    }, 


    async getPSO(){
      await axios
        .get(
          `${process.env.VUE_APP_API}/pso/get/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.pso = response.data.data;
          } else {
            console.log("got error");
          }
        });
      }
  },
};
</script>

<style scoped>

input{
  border: 1px solid black;
  border-radius: 10%;
}

td, thead, tr, th {
    text-align: center;
    padding: 10px 20px;
    border: 1px solid black !important;
}


.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
